import { useCallback } from 'react';

import { useReactFlow } from 'reactflow';

const useUpdateNodeData = () => {
    const { setNodes } = useReactFlow();

    const updateNodeData = useCallback((id: string, newConfig: any) => {
        setNodes((nodes) =>
            nodes.map((node) =>
                node.id === id ? { ...node, data: { ...node.data, ...newConfig } } : node
            )
        );
    }, [setNodes]);

    return updateNodeData;
}

export default useUpdateNodeData